'use client';

import clsx from 'clsx';
import { ReactNode, useState } from 'react';

import styles from '../Button.module.scss';

import { Icon } from '@/components/core';
import { IconsId } from '@/types/icons';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    iconName?: IconsId;
    hideArrow?: boolean;
}

export const ButtonClient: React.FC<ButtonProps> = ({ children, iconName, hideArrow = false, className, ...props }) => {
    const [lightPosition, setLightPosition] = useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = useState(false);
    const [arrowAnimation, setArrowAnimation] = useState(false);
    const handleMouseMove = (e: React.MouseEvent<HTMLButtonElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setLightPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    const handleMouseEnter = () => {
        setArrowAnimation(true);
        setIsHovering(true);
        setTimeout(() => {
            setArrowAnimation(false);
        }, 600);
    };

    return (
        <button
            className={clsx(styles.button, className, 'button', { [styles.hideArrow]: hideArrow })}
            type="button"
            onMouseMove={handleMouseMove}
            onMouseLeave={() => setIsHovering(false)}
            onMouseEnter={handleMouseEnter}
            {...props}
        >
            <div
                className={clsx(styles.lightEffect, 'lightEffect', { [styles.isHovering]: isHovering })}
                style={{
                    left: `${lightPosition.x}px`,
                    top: `${lightPosition.y}px`,
                }}
            />

            <span className={styles.childrenWrapper}>
                {iconName && <Icon name={iconName} />}
                {children}
            </span>
            {!hideArrow && (
                <div className={clsx(styles.arrowWrapper, { [styles.animate]: arrowAnimation })}>
                    <Icon name="longArrow" />
                </div>
            )}
        </button>
    );
};
